import uuid4 from "uuid4";

const REGEXP = /[xy]/g
const PATTERN = 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx';

function replacement(c) {
    let r = Math.random() * 16 | 0;
    let v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
}

export default function uuid_old() {
    return PATTERN.replace(REGEXP, replacement);
}


export const UUID = () => {
    const tokens = uuid4().split('-');
    if (!tokens) {
        return this.uuid();
    }
    return tokens[2] + tokens[1] + tokens[0] + tokens[3] + tokens[4];
    // return PATTERN.replace(REGEXP, replacement);
};

export const genApiKey = () => {
    const tokens = uuid4().toUpperCase().split('-');
    if (!tokens) {
        return this.uuid();
    }
    return `INTO_${tokens[0]}-${tokens[1] + tokens[2]}-${tokens[3]}-${tokens[4]}`;
}
